var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowupright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow up right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 4C6.5 3.86739 6.55268 3.74021 6.64645 3.64645C6.74021 3.55268 6.86739 3.5 7 3.5H12C12.1326 3.5 12.2598 3.55268 12.3536 3.64645C12.4473 3.74021 12.5 3.86739 12.5 4V9C12.5 9.13261 12.4473 9.25979 12.3536 9.35355C12.2598 9.44732 12.1326 9.5 12 9.5C11.8674 9.5 11.7402 9.44732 11.6464 9.35355C11.5527 9.25979 11.5 9.13261 11.5 9V4.5H7C6.86739 4.5 6.74021 4.44732 6.64645 4.35355C6.55268 4.25979 6.5 4.13261 6.5 4Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3539 3.64604C12.4005 3.69248 12.4374 3.74766 12.4626 3.80841C12.4878 3.86915 12.5008 3.93427 12.5008 4.00004C12.5008 4.06581 12.4878 4.13093 12.4626 4.19167C12.4374 4.25242 12.4005 4.30759 12.3539 4.35404L3.3539 13.354C3.26001 13.4479 3.13267 13.5007 2.9999 13.5007C2.86712 13.5007 2.73979 13.4479 2.6459 13.354C2.55201 13.2602 2.49927 13.1328 2.49927 13C2.49927 12.8673 2.55201 12.7399 2.6459 12.646L11.6459 3.64604C11.6923 3.59948 11.7475 3.56253 11.8083 3.53733C11.869 3.51212 11.9341 3.49915 11.9999 3.49915C12.0657 3.49915 12.1308 3.51212 12.1915 3.53733C12.2523 3.56253 12.3075 3.59948 12.3539 3.64604Z",
    fill: "#007BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowupright);
export default __webpack_public_path__ + "static/media/Arrow up right.00053afaa1f2ed37edc3931868966cc4.svg";
export { ForwardRef as ReactComponent };